import { Box } from '@mui/material'

import useStyles from '../../routes/alert-acknowledge/index.styles'

import AlertAckBlueHeader from './blue-header-svg'
import AlertAckRedHeader from './red-header-svg'

const Header = ({ variant }: { variant: 'red' | 'blue' }) => {
  const classes = useStyles
  return <Box sx={classes.header}>{variant === 'red' ? <AlertAckRedHeader /> : <AlertAckBlueHeader />}</Box>
}
export default Header
